module.exports = __webpack_public_path__ + "img/dashboard_1.4553d1c6.jpg";